/** Full-bleed app screenshots for HeroWithDemoOnBackground (Oatmeal home-02 style). */
import exploreDark from "@/assets/screenshots/explore-desktop-dark.png"
import exploreLight from "@/assets/screenshots/explore-desktop.png"

export function HeroSplashAppDemo() {
  const imageClassName = "h-full w-auto max-w-none bg-white/75 dark:hidden"
  const imageDarkClassName = "h-full w-auto max-w-none bg-black/75 not-dark:hidden"

  return (
    <>
      <img
        src={exploreLight}
        alt="ArtlessDev Explore view showing scenarios by feature"
        className={imageClassName}
      />
      <img src={exploreDark} alt="" aria-hidden className={imageDarkClassName} />
    </>
  )
}
